import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import '@/assets/tailwind.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import '@/plugins/axios'

import VueCookies from 'vue-cookies'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus).use(VueCookies).use(store).use(router).mount('#app')
